import React from 'react';
import PropTypes from 'prop-types';
import StructuredContent from '@nerdwallet/structured-content';
import { stringInputSpec, boolCheckboxSpec } from '../../lib/editing-configs';

const HomeInsuranceEntryPointWrapper = ({
  buttonAnnotation,
  buttonText,
  defaultZipCode,
  heading,
  pricingCode,
  subheading,
  isInternal,
}) => {
  return (
    <StructuredContent>
      {{
        type: 'HomeInsuranceEntryPoint',
        version: '1.0.0',
        props: {
          buttonAnnotation,
          buttonText,
          defaultZipCode,
          heading,
          pricingCode,
          subheading,
          isInternal,
        },
      }}
    </StructuredContent>
  );
};

HomeInsuranceEntryPointWrapper.propTypes = {
  /** Legal disclaimer displayed below the CTA */
  buttonAnnotation: PropTypes.string,
  /** Text on the CTA */
  buttonText: PropTypes.string,
  /** Default zipcode on first render */
  defaultZipCode: PropTypes.string,
  /** Heading text */
  heading: PropTypes.string,
  /** Partner's SRC code */
  pricingCode: PropTypes.string,
  /** Body text */
  subheading: PropTypes.string,
  /** Whether to redirect to in-house experience or partner's */
  isInternal: PropTypes.bool,
};

HomeInsuranceEntryPointWrapper.defaultProps = {
  buttonAnnotation: 'Matches provided by Insure.com',
  buttonText: 'GET STARTED',
  defaultZipCode: '94103',
  heading: 'Find the right home insurance at the right price',
  pricingCode: '662940',
  subheading:
    'Answer a few questions to compare personalized insurance matches.',
  isInternal: false,
};

HomeInsuranceEntryPointWrapper.getEditingConfig = () => {
  return [
    stringInputSpec('buttonAnnotation', 'Button Annotation'),
    stringInputSpec('buttonText', 'Button Text'),
    stringInputSpec('defaultZipCode', 'Default Zip Code'),
    stringInputSpec('heading', 'Heading'),
    stringInputSpec('pricingCode', 'Pricing Code'),
    stringInputSpec('subheading', 'Subheading'),
    boolCheckboxSpec('isInternal', 'Is Internal'),
  ];
};

HomeInsuranceEntryPointWrapper.displayName = 'HomeInsuranceEntryPointWrapper';

export default HomeInsuranceEntryPointWrapper;
